export const getStatus = state => state.signup.isUserRegistered;
